import { FC } from 'react'

export const Tokens: FC = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-white">Tokens</h1>
        <p className="mt-1 text-sm text-gray-400">
          Create and manage your branded tokens.
        </p>
      </div>
      
      <div className="bg-[#182233] shadow rounded-lg p-6">
        <p className="text-gray-400">Tokens page content coming soon...</p>
      </div>
    </div>
  )
}
